import { render } from "./InstructionComponent.vue?vue&type=template&id=4ffb183e&scoped=true"
import script from "./InstructionComponent.vue?vue&type=script&lang=js"
export * from "./InstructionComponent.vue?vue&type=script&lang=js"

import "./InstructionComponent.vue?vue&type=style&index=0&id=4ffb183e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffb183e"]])

export default __exports__